// import 'zone.js'; // for angular subapp
import {
    registerMicroApps,
    runAfterFirstMounted,
    start,
    setDefaultMountApp
} from 'qiankun';
import actions from '../action';
/**
 * 获取针对当前子应用的最新按钮权限
 * @param {object} appConfig - 子应用的配置对象
 * @returns {string[]} 按钮权限数组
 */
function getLatestButtonPermissions(appConfig) {
    // 示例：可以根据 appConfig.name 或其他上下文获取对应权限
    console.log(`正在为 ${appConfig.name} 获取最新权限...`);

    // 假设这是从您的后端或权限 Store 中获取的最新权限数组
    // ⚠️ 实际环境中您需要替换这里的逻辑
    const latestPermissions = window.__APP_PERMISSIONS__?.[appConfig.name] || [
        'default:read',
        'default:write'
    ];

    return latestPermissions;
}
// 在模块顶层创建一个可变的容器
const globalState = {
    buttonPermissions: []
};
const loader = () => {
    // console.log(loading);
};
export const appsData = [
    {
        name: 'powerTrading',
        entry: process.env.VUE_APP_POWER_TRADING,
        container: '#subapp-viewport',
        activeRule: '/powerTrading',
        loader,
        props: {
            name: '电力交易1.0'
        },
        sandbox: true
    },
    {
        name: 'enterpriseSearch',
        entry: process.env.VUE_APP_ENTER_SEARCH,
        container: '#subapp-viewport',
        activeRule: '/enterpriseSearch',
        loader,
        sandbox: true
    },
    {
        name: 'energyTesting',
        entry: process.env.VUE_APP_ENTER_TESTING,
        container: '#subapp-viewport',
        activeRule: '/energyTesting',
        loader,
        sandbox: true,
        props: {
            actions,
            routerBase: '/energyTesting', // 子应用的路由前缀(router的base)
            routerList: [] // 子应用的路由列表
        }
    },
    {
        name: 'transactionCalendar',
        entry: process.env.VUE_APP_TRANSACTION_CALENDAR,
        container: '#subapp-viewport',
        loader,
        activeRule: '/transactionCalendar',
        sandbox: true,
        props: {
            routerBase: '/transactionCalendar', // 子应用的路由前缀(router的base)
            routerList: [] // 子应用的路由列表
        }
    },
    {
        name: 'transactionCalendar3',
        entry: process.env.VUE_APP_TRANSACTION_CALENDAR3,
        container: '#subapp-viewport',
        loader,
        activeRule: '/transactionCalendar3',
        sandbox: true,
        props: {
            routerBase: '/transactionCalendar3', // 子应用的路由前缀(router的base)
            routerList: [] // 子应用的路由列表
        }
    },
    {
        name: 'spotElectricityPriceForecast',
        entry: process.env.VUE_APP_SPOT_ELECTRICITY_PRICE_FORECAST,
        container: '#subapp-viewport',
        activeRule: '/spotElectricityPriceForecast',
        sandbox: true,
        loader,
        props: {
            routerBase: '/spotElectricityPriceForecast', // 子应用的路由前缀(router的base)
            routerList: [] // 子应用的路由列表
        }
    },
    {
        name: 'holdKanban',
        entry: process.env.VUE_APP_HOLD_KANBAN,
        container: '#subapp-viewport',
        activeRule: '/holdKanban',
        sandbox: true,
        loader,
        props: {}
    },
    {
        name: 'holdKanban3',
        entry: process.env.VUE_APP_HOLD_KANBAN3,
        container: '#subapp-viewport',
        activeRule: '/holdKanban3',
        sandbox: true,
        loader,
        props: {}
    },
    {
        name: 'estimateDaypartingQuotation',
        entry: process.env.VUE_APP_ESTIMATE_DAYPARTING_QUOTATION,
        container: '#subapp-viewport',
        activeRule: '/estimateDaypartingQuotation',
        loader,
        sandbox: true
    },
    {
        name: 'planReview',
        entry: process.env.VUE_APP_PLAN_REVIEW,
        container: '#subapp-viewport',
        activeRule: '/planReview',
        loader,
        sandbox: true
    },
    {
        name: 'planReview3',
        entry: process.env.VUE_APP_PLAN_REVIEW3,
        container: '#subapp-viewport',
        activeRule: '/planReview3',
        loader,
        sandbox: true
    },
    {
        name: 'bangbotOperations',
        entry: process.env.VUE_APP_BANGBOT_OPERATIONS,
        container: '#subapp-viewport',
        activeRule: '/bangbotOperations',
        loader,
        sandbox: true
    },
    {
        name: 'bangbot',
        entry: process.env.VUE_APP_BANGBOT_UI,
        container: '#subapp-viewport',
        activeRule: '/bangbotUi',
        loader,
        sandbox: true
    },
    {
        name: 'planReviewE',
        entry: process.env.VUE_APP_PLAN_REVIEWE,
        container: '#subapp-viewport',
        activeRule: '/planReviewE',
        loader,
        sandbox: true
    },
    {
        name: 'customerManagement',
        entry: process.env.VUE_APP_CUSTOMER_MANAGEMENT,
        container: '#subapp-viewport',
        activeRule: '/customerManagement',
        loader,
        sandbox: true
    },
    {
        name: 'settlementManagement',
        entry: process.env.VUE_APP_SETTLEMENT_MANAGEMENT,
        container: '#subapp-viewport',
        activeRule: '/settlementManagement',
        loader,
        sandbox: true
    },
    {
        name: 'HistoricalElectricityConsumption',
        entry: process.env.VUE_APP_HISTORICAL_ELECTRICITY_CONSUMPTION,
        container: '#subapp-viewport',
        activeRule: '/HistoricalElectricityConsumption',
        loader,
        sandbox: true
    },
    {
        name: 'disclosureData',
        entry: process.env.VUE_APP_DISCLOSURE_DATA,
        container: '#subapp-viewport',
        activeRule: '/disclosureData',
        loader,
        sandbox: true
    },
    {
        name: 'operationManagement',
        entry: process.env.VUE_APP_OPERATION_MANAGEMENT_DATA,
        container: '#subapp-viewport',
        activeRule: '/operationManagement',
        loader,
        sandbox: true
    },
    {
        name: 'application',
        entry: process.env.VUE_APP_APPLICATION,
        container: '#subapp-viewport',
        activeRule: '/application',
        loader,
        sandbox: true,
        props: {
            actions,
            appid: sessionStorage.getItem('appid')
        }
    },
    {
        name: 'backstageManagement',
        entry: process.env.VUE_APP_BACKSTAGE_MANAGEMENT,
        container: '#subapp-viewport',
        activeRule: '/backstageManagement',
        loader,
        sandbox: true
    },
    {
        name: 'retailMarket',
        entry: process.env.VUE_APP_RETAILMARKET,
        container: '#subapp-viewport',
        activeRule: '/retailMarket',
        loader,
        sandbox: true
    },
    {
        name: 'cgd',
        entry: process.env.VUE_APP_CABLE_GAS,
        container: '#subapp-viewport',
        activeRule: '/cgd',
        loader,
        sandbox: true
    },
    {
        name: 'weatherForecast',
        entry: process.env.VUE_APP_WEATHERFORECAST,
        container: '#subapp-viewport',
        activeRule: '/weatherForecast',
        loader,
        sandbox: true
    },
    {
        name: 'weatherForecast3',
        entry: process.env.VUE_APP_WEATHERFORECAST3,
        container: '#subapp-viewport',
        activeRule: '/weatherForecast3',
        loader,
        sandbox: true
    },
    {
        name: 'noticeRelease',
        entry: process.env.VUE_APP_NOTICE_RELEASE,
        container: '#subapp-viewport',
        activeRule: '/noticeRelease',
        loader,
        sandbox: true
    },
    {
        name: 'energyStorage',
        entry: process.env.VUE_APP_ENERGYSTORAGE,
        container: '#subapp-viewport',
        activeRule: '/energyStorage',
        loader,
        sandbox: true
    },
    {
        name: 'energyStorage2',
        entry: process.env.VUE_APP_ENERGYSTORAGE2,
        container: '#subapp-viewport',
        activeRule: '/energyStorage2',
        loader,
        sandbox: true
    },
    {
        name: 'energyStorageControl',
        entry: process.env.VUE_APP_ENERGYSTORAGE_CONTROL,
        container: '#subapp-viewport',
        activeRule: '/energyStorageControl',
        loader,
        sandbox: true
    },
    {
        name: 'esHealthMonitoring',
        entry: process.env.VUE_APP_ES_HEALTH_MONITORING,
        container: '#subapp-viewport',
        activeRule: '/esHealthMonitoring',
        loader,
        sandbox: true
    },
    {
        name: 'energyMaintenance',
        entry: process.env.VUE_APP_ENERGYMAINTENANCE,
        container: '#subapp-viewport',
        activeRule: '/energyMaintenance',
        loader,
        sandbox: true
    },
    {
        name: 'workflow',
        entry: process.env.VUE_APP_WORKFLOWAPP,
        container: '#subapp-viewport',
        activeRule: '/workflow',
        loader,
        props: {
            name: '储能运维平台工作流',
            routerBase: '/workflow',
            actions
        },
        sandbox: true
    },
    {
        name: 'projectManagement',
        entry: process.env.VUE_APP_PROJECTMANAGEMENT,
        container: '#subapp-viewport',
        activeRule: '/projectManagement'
    },
    {
        name: 'projectManagementInside',
        entry: process.env.VUE_APP_PROJECTMANAGEMENTINSIDE,
        container: '#subapp-viewport',
        activeRule: '/projectManagementInside'
    },
    {
        name: 'intelligentTerminal',
        entry: process.env.VUE_APP_INTELLIGENTTERMINAL,
        container: '#subapp-viewport',
        activeRule: '/intelligentTerminal'
    },
    {
        name: 'powerGrid',
        entry: process.env.VUE_APP_POWERGRID,
        container: '#subapp-viewport',
        activeRule: '/powerGrid'
    },
    {
        name: 'virtualPowerPlant',
        entry: process.env.VUE_APP_VIRTUALPOWERPLANT,
        container: '#subapp-viewport',
        activeRule: '/virtualPowerPlant',
        sandbox: {
            strictStyleIsolation: true // 开启样式隔离
        },
        props: {
            actions
        }
    },
    {
        name: 'tenderingAndBidding',
        entry: process.env.VUE_APP_TENDERINGANDBIDDING,
        container: '#subapp-viewport',
        activeRule: '/tenderingAndBidding'
    },
    /* 3,0*/
    {
        name: 'enterpriseSearch3',
        entry: process.env.VUE_APP_ENTER_SEARCH3,
        container: '#subapp-viewport',
        activeRule: '/enterpriseSearch3',
        loader,
        sandbox: true
    },
    {
        name: 'customerManagement3',
        entry: process.env.VUE_APP_CUSTOMER_MANAGEMENT3,
        container: '#subapp-viewport',
        activeRule: '/customerManagement3',
        loader,
        sandbox: true
    },
    {
        name: 'spotElectricityPriceForecast3',
        entry: process.env.VUE_APP_SPOT_ELECTRICITY_PRICE_FORECAST3,
        container: '#subapp-viewport',
        activeRule: '/spotElectricityPriceForecast3',
        sandbox: true,
        loader,
        props: {
            routerBase: '/spotElectricityPriceForecast3', // 子应用的路由前缀(router的base)
            routerList: [] // 子应用的路由列表
        }
    },
    {
        name: 'backstageManagement3',
        entry: process.env.VUE_APP_BACKSTAGE_MANAGEMENT3,
        container: '#subapp-viewport',
        activeRule: '/backstageManagement3',
        loader,
        sandbox: true
    },
    {
        name: 'electricityMarketDataCenter',
        entry: process.env.VUE_APP_ELECTRICITY_MARKET_DATA_CENTER,
        container: '#subapp-viewport',
        activeRule: '/electricityMarketDataCenter',
        loader,
        sandbox: true
    },
    // 分布式电源
    {
        name: 'distributedPower',
        entry: process.env.VUE_APP_DISTRIBUTEDPOWER,
        container: '#subapp-viewport',
        activeRule: '/distributedPower'
    },
    // 资产墙
    {
        name: 'assetWall',
        entry: process.env.VUE_APP_ASSETWALL,
        container: '#subapp-viewport',
        activeRule: '/assetWall'
    },
    {
        name: 'heavyOverload',
        entry: process.env.VUE_APP_HEAVY_OVERLOAD,
        container: '#subapp-viewport',
        activeRule: '/heavyOverload',
        loader,
        sandbox: true
    },
    {
        name: 'smallPowerplantAuxiliaryManagement',
        entry: process.env.VUE_APP_SMALL_POWER_PLANT_AUXILIARY_MANAGEMENT,
        container: '#subapp-viewport',
        activeRule: '/smallPowerplantAuxiliaryManagement',
        loader,
        sandbox: true
    },
    {
        name: 'czHeavyOverload',
        entry: process.env.VUE_APP_CZ_HEAVY_OVER_LOAD,
        container: '#subapp-viewport',
        activeRule: '/czHeavyOverload',
        loader,
        sandbox: true
    },
    //长治煤矿同源预警系统
    {
        name: 'czCoalmineHomologous',
        entry: process.env.VUE_APP_CZ_MINE_WARNING,
        container: '#subapp-viewport',
        activeRule: '/czCoalmineHomologous',
        loader,
        sandbox: true
    },
    // 大同安监
    {
        name: 'daTongSafety',
        entry: process.env.VUE_APP_DATONG_ANJIAN,
        container: '#subapp-viewport',
        activeRule: '/daTongSafety',
        loader,
        sandbox: true
    },
    //同期线损
    {
        name: 'samePeriodLines',
        entry: process.env.VUE_APP_SPOT_LOSS,
        container: '#subapp-viewport',
        activeRule: '/samePeriodLines'
    },
    // 持证上岗小程序-管理端
    {
        name: 'czsgMpPc',
        entry: process.env.VUE_APP_CZSG_MP_PC,
        container: '#subapp-viewport',
        activeRule: '/czsgMpPc'
    },
    // 电科院线损
    {
        name: 'electricLossLines',
        entry: process.env.VUE_APP_DKY_LINE_LOSS,
        container: '#subapp-viewport',
        activeRule: '/electricLossLines',
        loader,
        sandbox: true
    },
    // 太供检修计划风险评估
    {
        name: 'maintenancePlan',
        entry: process.env.VUE_APP_MAINTENANCE_PLAN,
        container: '#subapp-viewport',
        activeRule: '/maintenancePlan',
        loader,
        sandbox: true
    },
    // 储能项目资料库
    {
        name: 'projectRepository',
        entry: process.env.VUE_APP_PROJECT_REPOSITORY,
        container: '#subapp-viewport',
        activeRule: '/projectRepository',
        loader,
        sandbox: true
    },
    // 电力现货模拟仿真系统
    {
        name: 'dkySimulation',
        entry: process.env.VUE_APP_DKY_SIMULATION,
        container: '#subapp-viewport',
        activeRule: '/dkySimulation',
        loader,
        sandbox: true
    },
    // 长治调度日报
    {
        name: 'dispatchDaityReport',
        entry: process.env.VUE_APP_DISPATCH_DAITY_REPORT,
        container: '#subapp-viewport',
        activeRule: '/dispatchDaityReport',
        loader,
        sandbox: true
    },
    // 忻州调度日报
    {
        name: 'xzDispatchDaityReport',
        entry: process.env.VUE_APP_XZ_DISPATCH_DAITY_REPORT,
        container: '#subapp-viewport',
        activeRule: '/xzDispatchDaityReport',
        loader,
        sandbox: true
    },
    // 保护定值单管理系统
    {
        name: 'protectionSettingManager',
        entry: process.env.VUE_APP_PROTECTION_SETTING_MANAGER,
        container: '#subapp-viewport',
        activeRule: '/protectionSettingManager'
    },
    //大屏播放器
    {
        name: 'screenplayer',
        entry: process.env.VUE_APP_SCREEN_PLAYER,
        container: '#subapp-viewport',
        activeRule: '/screenplayer'
    },
    //长治点表
    {
        name: 'czPointMeter',
        entry: process.env.VUE_APP_CZ_POINT_METER,
        container: '#subapp-viewport',
        activeRule: '/czPointMeter'
    }
];
// 动态注册子应用的函数
export function dynamicRegisterApps(app, buttonPermissions = []) {
    // 更新全局状态
    globalState.buttonPermissions = buttonPermissions;
    globalState.appId = sessionStorage.getItem('appid');
    const apps = app.map((appConfig) => ({
        ...appConfig,
        props: {
            ...appConfig.props,
            // 传递当前路径信息
            currentPath: location.pathname,
            // 传递actions用于通信
            actions: appConfig.props?.actions || actions
        }
    }));
    actions.setGlobalState({
        noToken: false,
        buttonPermissions: globalState.buttonPermissions,
        appId: globalState.appId,
        pushStateTime: ''
    });
    // 注册微应用，并配置生命周期钩子
    registerMicroApps(apps, {
        // --- 核心优化点：在应用挂载后广播最新权限 ---
        afterMount: [
            (app) => {
                actions.setGlobalState({
                    noToken: false,
                    buttonPermissions: globalState.buttonPermissions,
                    appId: globalState.appId
                });
            }
        ],
        // 其他钩子保持不变
        beforeLoad: [
            /* ... */
        ],
        beforeMount: [
            /* ... */
        ],
        afterUnmount: [
            (app) => {
                console.log(`[Qiankun Hook] ${app.name} 已卸载.`);
                // 卸载后，可以考虑清除全局状态中对应的权限，但这通常在子应用内部的 unmount 钩子中处理
            }
        ]
    });
}

// router.beforeEach(async (to, from, next) => {
//     let pathname = location.pathname;
//         let url = '/' + pathname.split('/')[1];
//         let arr = appsData.filter((item) => {
//             return item.activeRule === url;
//         });
//         dynamicRegisterApps(arr);
//         next();
//
// });

// 启动 qiankun
start({
    prefetch: true
    // 其他配置...
});
actions.onGlobalStateChange((state, preState) => {
    console.log(state, preState, '1111');
});
